import { PageController } from '@client/components/_core/layout/PageController';
import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { tokenValues } from '@client/design-system/__generated__';
import { MIN_BROWSER_VERSIONS } from '@client/utils';
import { createFileRoute } from '@tanstack/react-router';
import { AlertTriangle } from 'lucide-react';

export const Route = createFileRoute('/not-supported')({
    component: NotSupported,
});

function NotSupported() {
    // Display versions using the shared constants
    const browserVersions = {
        Chrome: `${MIN_BROWSER_VERSIONS.CHROME}+`,
        Firefox: `${MIN_BROWSER_VERSIONS.FIREFOX}+`,
        Edge: 'Chromium', // No specific min version check in browserUtils for Chromium Edge
        Safari: `${MIN_BROWSER_VERSIONS.SAFARI}+`,
    };

    return (
        <PageController route={Route}>
            <div className="grid min-h-screen w-full place-items-center bg-muted p-4">
                <div className="w-full max-w-lg text-center">
                    <img src="/static/curium-logo.svg" alt="Curium Logo" className="mx-auto mb-12 h-10 w-auto" />

                    <div className="rounded-lg bg-card p-10 text-center shadow-sm">
                        <div className="mb-6">
                            <AlertTriangle
                                style={{ width: '64px', height: '64px', color: tokenValues.color.role.gold }}
                            />
                        </div>

                        <h1 className="mb-3 font-medium text-2xl">Update Your Browser</h1>

                        <p className="mb-8 text-subtle-foreground">
                            Your current browser isn't supported. For the best security and experience, please update or
                            switch to one of these recommended browsers:
                        </p>

                        <div className="grid grid-cols-2 gap-3">
                            <a
                                href="https://www.google.com/chrome/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full"
                            >
                                <Button type="primary" block>
                                    Get Chrome {browserVersions.Chrome}
                                </Button>
                            </a>

                            <a
                                href="https://www.mozilla.org/firefox/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full"
                            >
                                <Button type="secondary" block>
                                    Get Firefox {browserVersions.Firefox}
                                </Button>
                            </a>

                            <a
                                href="https://www.microsoft.com/edge"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full"
                            >
                                <Button type="secondary" block>
                                    Get Edge ({browserVersions.Edge})
                                </Button>
                            </a>

                            <a
                                href="https://support.apple.com/downloads/safari"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-full"
                            >
                                <Button type="secondary" block>
                                    Get Safari {browserVersions.Safari}
                                </Button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </PageController>
    );
}
